
import { User } from '../auth/User';
import { InviteUserPayload, TempUser } from '../types/DhqUserInvite';
import { ApiRoutes, getFullApiRoute, replaceRouteParams } from './ApiRoutes';
import { HttpRequest } from './HttpRequest';

export class DhqMigrationAPI {

    /**
     * Get pending invitation count for a company
     * @param tenantId - The ID of the tenant/company
     * @returns The count of pending invitations
     */
    static async getPendingInvitationCount(user: User, tenantId: string): Promise<number> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.PENDING_TEMP_USER_COUNT), { tenantId }),
            'GET',
            null,
            null,
            user
        );
        return result?.count;
    }


    /**
     * Retrieves a list of temporary users that can be invited to a specific company/tenant.
     * 
     * @param user - The authenticated user making the request
     * @param tenantId - The unique identifier of the tenant/company to get invitable users for
     * @returns A promise that resolves to an array of TempUser objects representing users that can be invited
     * @throws May throw an error if the HTTP request fails or if the user lacks proper permissions
     */
    static async getUsersToInviteForCompany(user: User, tenantId: string): Promise<TempUser[]> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.USERS_TO_INVITE_FOR_COMPANY), { tenantId }),
            'GET',
            null,
            null,
            user
        );
        return result;
    }

    /**
     * Invites temporary users to a company by sending an HTTP POST request to the invite endpoint.
     * 
     * @param user - The authenticated user making the invitation request
     * @param body - The payload containing temporary user invitation details
     * @returns A Promise that resolves when the invitation is successfully sent
     * @throws May throw an error if the HTTP request fails or if the API returns an error response
     */
    static async inviteTempUsersToCompany(user: User, body: InviteUserPayload): Promise<void> {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const result = await HttpRequest(
            getFullApiRoute(ApiRoutes.INVITE_TEMP_USERS),
            'POST',
            body,
            headers,
            user
        );
        return result;
    }
}
